// extracted by mini-css-extract-plugin
export default {"valid":"styles_valid__hzNns"};